<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">HISTORY OF WOLVES</h1>
<p class="title"><em>A Novel</em></p>
<h2 class="author"><em>Emily Fridlund</em></h2>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?8b5af1da